import { FC } from 'react';
import { EnergyGrade } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import { EnergimerkeV2025 } from '../../../types/energimerke';

import KarakterA from './../../../assets/energimerke/energikarakter-ikon/a.svg?react';
import KarakterB from './../../../assets/energimerke/energikarakter-ikon/b.svg?react';
import KarakterC from './../../../assets/energimerke/energikarakter-ikon/c.svg?react';
import KarakterD from './../../../assets/energimerke/energikarakter-ikon/d.svg?react';
import KarakterE from './../../../assets/energimerke/energikarakter-ikon/e.svg?react';
import KarakterF from './../../../assets/energimerke/energikarakter-ikon/f.svg?react';
import KarakterG from './../../../assets/energimerke/energikarakter-ikon/g.svg?react';
import Empty from './../../../assets/energimerke/energikarakter-ikon/empty.svg?react';

interface Props {
  energimerke: EnergimerkeV2025;
}

export const EnergikarakterV2025: FC<Props> = ({ energimerke }) => {
  const { t } = useTranslation();

  const titleText = t('energimerke.energikarakter.title', {
    energikarakter: energimerke?.energikarakter
  });

  switch (energimerke?.energikarakter) {
    case EnergyGrade.A:
      return <KarakterA title={titleText} />;
    case EnergyGrade.B:
      return <KarakterB title={titleText} />;
    case EnergyGrade.C:
      return <KarakterC title={titleText} />;
    case EnergyGrade.D:
      return <KarakterD title={titleText} />;
    case EnergyGrade.E:
      return <KarakterE title={titleText} />;
    case EnergyGrade.F:
      return <KarakterF title={titleText} />;
    case EnergyGrade.G:
      return <KarakterG title={titleText} />;
    default:
      return <Empty title={t('energimerke.energikarakter.empty')} />;
  }
};
